import { Navigate, useLocation } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../config/firebase";
import { useAppSelector } from "../redux/reduxHook/useAuthActions";

export default function RequireAuth({ children }) {
  const [user, loading] = useAuthState(auth);
  const location = useLocation();
  const isCorrupted = useAppSelector((state) => state.auth.isCorrupted);

  if (loading) return null; // or a spinner

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // If flagged as corrupted, FORCE them to the recovery page
  if (isCorrupted && location.pathname !== "/corrupted-account") {
    return <Navigate to="/corrupted-account" replace />;
  }

  return children;
}